var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('bootstrap/transition');
require('bootstrap/collapse');
var vein = require('veinjs');

var BODY_SELECTOR = 'body';
var FORM_SELECTOR = 'form';
var MAIN_CATEGORY_FILTERS_TAG_SELECTOR = '.main-category-filters__tag';
var DATA_RESET_SELECTOR = '[data-reset]';
var DATA_TIER_1_SELECTOR = '[data-tier="1"]';
var DATA_TIER_2_SELECTOR = '[data-tier="2"]';
var DATA_CATEGORY_SELECTOR = '[data-category]';
var DATA_TOGGLE_EXPLORE_SELECTOR = '[data-toggle="explore"]';
var JS_TAG_SELECT_SELECTOR = '.js-tag-select';

var MAIN_CATEGORY_FILTER_CLASS = 'main-category-filters-open';
var JS_TAG_SELECT_CLASS = 'js-tag-select';
var JS_IS_DISABLED_CLASS = 'js-is-disabled';
var JS_IS_SELECTED_CLASS = 'js-is-selected';
var CATEGORY_FILTERED_CLASS = 'main-category-filtered';

var MAIN_CATEGORY_LISTING_SELECTOR = '.js-main-category-listing';
var RESULTS_CATEGORY_HEADER_SELECTOR = '.js-results-category-header';
var RESULTS_CATEGORY_COLLAPSE_SELECTOR = '.js-results-category-collapse';
var RESULTS_CATEGORY_HEADER_H2_SELECTOR = '.results-category__header h2';
var RESULTS_CATEGORY_SELECTOR = '.js-results-category';
var RESULTS_CATEGORY_GRID_SELECTOR = '.js-results-category-grid';
var PAGINATION_SELECTOR = '.js-pagination';
var PAGE_NUMBERS_SELECTOR = '.js-page-numbers';

function MainCategoryFilters(el) {
	this.$el = $(el);
	this.$type = this.$el.data('type');

	this.$body = $(BODY_SELECTOR);
	this.$tags = this.$el.find(MAIN_CATEGORY_FILTERS_TAG_SELECTOR);
	this.$form = this.$el.find(FORM_SELECTOR);
	this.$tier1 = this.$el.find(DATA_TIER_1_SELECTOR);
	this.$tier2 = this.$el.find(DATA_TIER_2_SELECTOR);
	this.filters = {
		'tier1': 'all',
		'tier2': []
	};

	// Disable filter by other categories
	this.disableFilters($(DATA_CATEGORY_SELECTOR));

	// click button filter open main category filters on mobile
	$(DATA_TOGGLE_EXPLORE_SELECTOR).on('click', function() {
		this.$body.toggleClass(MAIN_CATEGORY_FILTER_CLASS);
	}.bind(this));


	// Form radio on change
	$(document).on('change', 'input', function(e) {
		var $current = $(e.target),
			$tag;

		var resultsCategories = $(RESULTS_CATEGORY_SELECTOR);
		if (resultsCategories.length > 0) {
			resultsCategories.each(function() {
				var target_slug = $(this).data('slug');
				if ('all' == $current.val()) {
					$(this).show();
				} else {
					var currentList = $(this).find(RESULTS_CATEGORY_GRID_SELECTOR);
					var action = currentList.data('action');
					if (action === 'fetch_picks') {
						if (target_slug == $current.val() ) {
							$(this).show();
						} else {
							$(this).hide();
						}
					} else {
						$(this).show();
					}
				}
			});
		}

		if (parseInt($current.data('tier')) === 1) {
			$(JS_TAG_SELECT_SELECTOR).removeClass(JS_TAG_SELECT_CLASS);
			this.filters.tier1 = $current.val();
		} else {
			$tag = $current.closest('label');
			$tag.toggleClass(JS_TAG_SELECT_CLASS);
			this.filters.tier2 = [];
			this.$tier2.filter(':checked').each(function(i, checkbox) {
				this.filters.tier2.push(checkbox.value);
			}.bind(this));

			if (this.$type === 'event') {
				var selectedTags = this.filters.tier2;
				$(RESULTS_CATEGORY_SELECTOR).hide();
				var resultsCategories = $(RESULTS_CATEGORY_SELECTOR);
				if (resultsCategories.length > 0) {
					resultsCategories.each(function() {
						var target_slug = $(this).data('slug');
						if (selectedTags.includes(target_slug)) {
							$(this).show();
						}
					});
				} else {
					$(RESULTS_CATEGORY_SELECTOR).show();
				}
			}
		}
		this.filter_tags($current.val());
		this.filter();
	}.bind(this));

    // Resetting radios to unchecked when resetting filters
    $(DATA_RESET_SELECTOR).on('click', function(e) {
        e.preventDefault();
        this.$body.removeClass(CATEGORY_FILTERED_CLASS);
        $(JS_TAG_SELECT_SELECTOR).removeClass(JS_TAG_SELECT_CLASS);

        this.$tier1.filter('[value="all"]').prop('checked', true);
        this.$tier2.prop('checked', false);

        this.filters.tier1 = 'all';
        this.filters.tier2 = [];

		// Reset filter show all list pick-category
		var resultsCategories = $(RESULTS_CATEGORY_SELECTOR);
		if (resultsCategories.length > 0) {
			resultsCategories.show();
		}

		this.filter_tags('all');
        this.filter();
    }.bind(this));

	// listing
	$(MAIN_CATEGORY_LISTING_SELECTOR).on('click', RESULTS_CATEGORY_HEADER_SELECTOR, function (event) {
		var $this = $(this);
		var $target = $(event.target);
		var collapse = RESULTS_CATEGORY_COLLAPSE_SELECTOR;
		var notToggle = ($target.parents(collapse).length === 0 && !$target.is(collapse));
		if ( notToggle ) {
			$this.find(collapse).click();
		}
		return;
	});

	$(MAIN_CATEGORY_LISTING_SELECTOR).on('show.bs.collapse', '*', function () {
		var $results = $(this).closest(RESULTS_CATEGORY_SELECTOR);
		$results.addClass('open').find(RESULTS_CATEGORY_HEADER_H2_SELECTOR).addClass('active');
		$results.find(PAGINATION_SELECTOR).show();
	}).on('hide.bs.collapse', '*', function () {
		var $results = $(this).closest(RESULTS_CATEGORY_SELECTOR);
		$results.removeClass('open').find(RESULTS_CATEGORY_HEADER_H2_SELECTOR).removeClass('active');
		$results.find(PAGINATION_SELECTOR).hide();
	});

	// pagination
	var pagination_list = $(PAGINATION_SELECTOR);

	var $this = this;
	$(document).ready(function() {
		var page_num = 1;
		if (pagination_list.length > 0) {
			pagination_list.each(function() {
				var pagination_target = $(this);
				var total_records = pagination_target.data('total-records');
				$this.init_pagination(page_num, pagination_target, total_records);
			});
			$(document).on('click', PAGE_NUMBERS_SELECTOR, function(e) {
				e.preventDefault();
				var target = e.target;
				var page = $(target).data('page');
				var parent = $(target).closest(RESULTS_CATEGORY_SELECTOR);
				var currentPagination = $(parent).find(PAGINATION_SELECTOR);
				var currentList = $(parent).find(RESULTS_CATEGORY_GRID_SELECTOR);
				var tier1 = $this.filters.tier1;
				var tier2 = $this.filters.tier2;
				$this.make_call(page, currentList, currentPagination, tier1, tier2);
			});
		}
	});
}

MainCategoryFilters.prototype.init_pagination = function(page_num, pagination, total_records) {
	if (pagination) {
		pagination.attr('data-total-records', total_records);
		var per_page = pagination.data('per-page');
		var total_pages = Math.ceil(total_records / per_page);
		pagination.html('');
		if (total_pages > 7) {
			if (page_num == 1) {
				pagination.append('<a class="page-numbers js-page-numbers prev disabled" href="javascript:void(0)"><span class="icon-previous"></span></a>');
				pagination.append('<span class="page-numbers current" aria-current="page">1</span>');
			} else {
				pagination.append('<a class="page-numbers js-page-numbers prev" href="javascript:void(0)" data-page=""+(page_num-1)+""><span class="icon-previous"></span></a>');
				pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="1">1</a>');
			}

			if (total_pages - page_num > 3) {
				if (page_num > 4) {
					pagination.append('<span class="page-numbers">...</span>');
					pagination.append('<a class="page-number js-page-numbers" href="javascript:void(0)" data-page="'+(page_num - 1)+'">'+(page_num - 1)+'</a>');
					pagination.append('<span class="page-numbers current" aria-current="page" data-page="'+(page_num)+'">'+(page_num)+'</span>');
					pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="'+(page_num + 1)+'">'+(page_num + 1)+'</a>');
				} else {
					var page_no = 2;
					  for (page_no = 2; page_no <= 5; page_no++) {
						if (page_num == page_no) {
							pagination.append('<span class="page-numbers current" aria-current="page" data-page="'+(page_no)+'">'+(page_no)+'</span>');
						} else {
							pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="'+(page_no)+'">'+(page_no)+'</a>');
						}
					  }
				}
			}

			if (total_pages - page_num < 4) {
				pagination.append('<span class="page-numbers">...</span>');
				var page_no = total_pages - 4;
				for (page_no = total_pages - 4; page_no <= total_pages - 1; page_no++) {
					  if (page_num == page_no) {
						pagination.append('<span class="page-numbers current" aria-current="page">'+(page_no)+'</span>');
					  } else {
						pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="'+(page_no)+'">'+(page_no)+'</a>');
					  }
				}
			} else {
				pagination.append('<span class="page-numbers">...</span>');
			}

			if (page_num == total_pages) {
				pagination.append('<span class="page-numbers current" aria-current="page" data-page="'+(total_pages)+'">'+(total_pages)+'</span>');
				pagination.append('<span class="page-numbers next disabled"><span class="icon-next"></span></span>');
			} else {
				pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="'+(total_pages)+'">'+(total_pages)+'</a>');
				pagination.append('<a class="page-numbers next js-page-numbers" href="javascript:void(0)" data-page"'+(page_num + 1)+'"><span class="icon-next"></span></a>');
			}
		} else {
			if (total_pages > 1) {
				if (page_num == 1) {
					pagination.append('<span class="page-numbers prev disabled"><span class="icon-previous"></span></span>');
				} else {
					pagination.append('<a class="page-numbers prev js-page-numbers" href="javascript:void(0)" data-page="'+(page_num - 1)+'"><span class="icon-previous"></span></a>');
				}

				var page_no = 1;
				for (page_no = 1; page_no <= total_pages; page_no++) {
					if (page_num == page_no) {
						pagination.append('<span class="page-numbers current" aria-current="page">'+(page_no)+'</span>');
					} else {
						pagination.append('<a class="page-numbers js-page-numbers" href="javascript:void(0)" data-page="'+(page_no)+'">'+(page_no)+'</a>');
					}
				}

				if (page_num == total_pages) {
					pagination.append('<span class="page-numbers next disabled"><span class="icon-next"></span></span>');
				} else {
					pagination.append('<a class="page-numbers next js-page-numbers" href="javascript:void(0)" data-page="'+(page_num + 1)+'"><span class="icon-next"></span></a>');
				}
			}
		}
	}
};

MainCategoryFilters.prototype.fetch_data = function (per_page = 4, page_num, list, pagination, parent_level = [], child_level = []) {
	if (list && pagination) {
		var parent = list.closest(RESULTS_CATEGORY_SELECTOR);
		var tag = parent.data('category');
		var term_slug = list.data('term-slug');
		var action = list.data('action');
		var $this = this;
		$.ajax({
			type: 'get',
			url: "/wp-admin/admin-ajax.php",
			data: {
				action: action,
				page: page_num,
				per_page: per_page,
				term_slug: term_slug,
				parent_level: parent_level,
				child_level: child_level,
			},
			dataType: 'json',
			success: function(response) {
				if (response && response.html) {
					if ($this.$type === 'event') {
						if (response.total <= 0) {
							parent.hide();
							$('input[data-tier="2"][value="' + tag + '"]').prop('disabled', true).closest(MAIN_CATEGORY_FILTERS_TAG_SELECTOR).addClass(JS_IS_DISABLED_CLASS);
						} else {
							$('input[data-tier="2"][value="' + tag + '"]').prop('disabled', false).closest(MAIN_CATEGORY_FILTERS_TAG_SELECTOR).removeClass(JS_IS_DISABLED_CLASS);
							list.html('');
							list.html(response.html);
							$this.init_pagination(page_num, pagination, response.total);
						}
					} else {
						list.html('');
						list.html(response.html);
						$this.init_pagination(page_num, pagination, response.total);
					}
				}
			},
			error: function(e) {
				console.log(e);
			}
		});
	}
};

MainCategoryFilters.prototype.make_call = function(page_num, list, pagination, tier1, tier2) {
	if (pagination) {
		var per_page = pagination.data('per-page');
		this.fetch_data(per_page, page_num, list, pagination, tier1, tier2);
	}
};

MainCategoryFilters.prototype.filter_tags = function(value) {
	var $this = this;
	var resultsCategories = $(RESULTS_CATEGORY_SELECTOR);
	if (resultsCategories.length > 0) {
		resultsCategories.each(function() {
			var target_slug = $(this).data('slug');
			var resultsCategory = $(this);
			var page = 1;
			var currentPagination = $(resultsCategory).find(PAGINATION_SELECTOR);
			var currentList = $(resultsCategory).find(RESULTS_CATEGORY_GRID_SELECTOR);
			var action = currentList.data('action');
			if ('all' == value) {
				$this.make_call(page, currentList, currentPagination, $this.filters.tier1, $this.filters.tier2);
			} else {
				if ((action === 'fetch_picks' && target_slug == value) || action === 'fetch_events') {
					$this.make_call(page, currentList, currentPagination, $this.filters.tier1, $this.filters.tier2);
				}
			}
		});
	}
};

// function filter
MainCategoryFilters.prototype.filter = function() {
	var $matched = $([]),
		$matchedTier1 = $(DATA_CATEGORY_SELECTOR);

	$matchedTier1.removeClass(JS_IS_SELECTED_CLASS);

	if ( this.filters.tier1 === 'all' && this.filters.tier2.length === 0) {
		this.$body.removeClass(CATEGORY_FILTERED_CLASS);
		this.disableFilters($matchedTier1);
		return;
	} else {
		this.$body.addClass(CATEGORY_FILTERED_CLASS);
	}

	if (this.filters.tier1 !== 'all') {
		$matchedTier1 = $matchedTier1.filter('[data-category*="' + this.filters.tier1 + '"]');
	}

	if (this.filters.tier2.length === 0) {
		$matched = $matchedTier1;
	} else {
		$.each(this.filters.tier2, function(i, selectedCategory) {
			$matched = $matched.add($matchedTier1.filter('[data-category*="' + selectedCategory + '"]'));
		});
	}

	$matched.addClass(JS_IS_SELECTED_CLASS);

	if (this.$type !== 'event') {
		this.disableFilters($matched);
	}
};

// function disable filters
MainCategoryFilters.prototype.disableFilters = function($collection) {
	this.$tags.addClass(JS_IS_DISABLED_CLASS);
	this.$tier2.prop('disabled', true);

	$collection.each(function(i, element) {
		var $element = $(element),
			categories = $element.data('category').split(',');

		for (var j = 0; j < categories.length; j++) {
			$('input[data-tier="2"][value="' + categories[j] + '"]').prop('disabled', false).closest(MAIN_CATEGORY_FILTERS_TAG_SELECTOR).removeClass(JS_IS_DISABLED_CLASS);
		}
	});
};

module.exports = MainCategoryFilters;
